import React from 'react'
import FormTest from './formTest';
import FormFinal from './formFinal';
import Control from '../store/control';


const SideForm = () => {
  const type = Control.Get('type');

  switch(type) {
    case 'TestSocket':
      return <FormTest/>;
    case 'FinalDevice':
      return <FormFinal/>;
    default:
      return null;
  }
}

export default SideForm;
